var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    { attrs: { visible: "", width: "65%" }, on: { close: _vm.onCancel } },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _c("span", { staticClass: "font18" }, [
          _vm._v(
            _vm._s(
              _vm.initData.id ? _vm.$t("COMMON_EDIT") : _vm.$t("COMMON_ADD")
            )
          ),
        ]),
      ]),
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "140px" } },
        [
          _vm.active === "1"
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.newsTitle"),
                      rules: _vm.validateTip,
                      prop: "newsTitle",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "100", "show-word-limit": "" },
                      model: {
                        value: _vm.form.newsTitle,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "newsTitle", $$v)
                        },
                        expression: "form.newsTitle",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.newsDesc"),
                      rules: _vm.validateTip,
                      prop: "newsDesc",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        maxlength: "500",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.form.newsDesc,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "newsDesc", $$v)
                        },
                        expression: "form.newsDesc",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.linkText"),
                      rules: _vm.validateTip,
                      prop: "linkText",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "100", "show-word-limit": "" },
                      model: {
                        value: _vm.form.linkText,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "linkText", $$v)
                        },
                        expression: "form.linkText",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.linkUrl"),
                      rules: _vm.validateTip,
                      prop: "linkUrl",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        maxlength: "500",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.form.linkUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "linkUrl", $$v)
                        },
                        expression: "form.linkUrl",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.newsOrder"),
                      rules: _vm.validateTip,
                      prop: "newsOrder",
                    },
                  },
                  [
                    _c("el-input-number", {
                      attrs: { "controls-position": "right", min: 0 },
                      model: {
                        value: _vm.form.newsOrder,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "newsOrder", $$v)
                        },
                        expression: "form.newsOrder",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.active === "2"
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.docCategory"),
                      rules: _vm.validateTip,
                      prop: "docCategory",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.form.docCategory,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "docCategory", $$v)
                        },
                        expression: "form.docCategory",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.docCatalog"),
                      rules: _vm.validateTip,
                      prop: "docCatalog",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "50", "show-word-limit": "" },
                      model: {
                        value: _vm.form.docCatalog,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "docCatalog", $$v)
                        },
                        expression: "form.docCatalog",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.docName"),
                      rules: _vm.validateTip,
                      prop: "docName",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "100", "show-word-limit": "" },
                      model: {
                        value: _vm.form.docName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "docName", $$v)
                        },
                        expression: "form.docName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.hyperlink"),
                      rules: _vm.validateTip,
                      prop: "hyperlink",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        maxlength: "500",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.form.hyperlink,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "hyperlink", $$v)
                        },
                        expression: "form.hyperlink",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.docOrder"),
                      rules: _vm.validateTip,
                      prop: "docOrder",
                    },
                  },
                  [
                    _c("el-input-number", {
                      attrs: { "controls-position": "right", min: 0 },
                      model: {
                        value: _vm.form.docOrder,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "docOrder", $$v)
                        },
                        expression: "form.docOrder",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.active === "3"
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.materialTitle"),
                      rules: _vm.validateTip,
                      prop: "materialTitle",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "100", "show-word-limit": "" },
                      model: {
                        value: _vm.form.materialTitle,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "materialTitle", $$v)
                        },
                        expression: "form.materialTitle",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.materialCategory"),
                      rules: _vm.validateTip,
                      prop: "materialCategory",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: "", "show-word-limit": "" },
                      model: {
                        value: _vm.form.materialCategory,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "materialCategory", $$v)
                        },
                        expression: "form.materialCategory",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.linkUrl"),
                      rules: _vm.validateTip,
                      prop: "linkUrl",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        maxlength: "500",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.form.linkUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "linkUrl", $$v)
                        },
                        expression: "form.linkUrl",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newsMgt.materialOrder"),
                      rules: _vm.validateTip,
                      prop: "materialOrder",
                    },
                  },
                  [
                    _c("el-input-number", {
                      attrs: { "controls-position": "right", min: 0 },
                      model: {
                        value: _vm.form.materialOrder,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "materialOrder", $$v)
                        },
                        expression: "form.materialOrder",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.onConfirm("form")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }